module.exports = __webpack_public_path__ + "img/info-circle-yellow.14dd7d75.svg";